export default __webpack_public_path__ + "static/last-min-flight-hacks-68d526a604c58626a8757e5231e7d4ef.jpg";